<template>
  <v-container fluid class="px-12 py-4" v-if="organization">
    <v-row>
      <v-col cols="12" lg="8">
        <breadcrumbs></breadcrumbs>
        <h1>Billing and Finance</h1>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="8">
        <v-card outlined>
          <v-card-text>
            <v-list>
              <v-subheader
                ><span class="body-1"
                  >Organization Billing Information</span
                ></v-subheader
              >
              <v-list-item-group>
                <v-list-item :to="{ name: 'exportBillingClinicInformation' }">
                  <v-list-item-avatar>
                    <v-icon color="accent" small>fas fa-link</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Clinic Information</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>url</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>

                <v-list-item :to="{ name: 'exportBillingTrizetto' }">
                  <v-list-item-avatar>
                    <v-icon color="accent" small>fas fa-link</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>DCW for Trizetto</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>url</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>

                <v-list-item :disabled="!payorListUrl" :href="payorListUrl">
                  <v-list-item-avatar>
                    <v-icon color="accent" small>fas fa-download</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >Payor List (imported by user)</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>xlsx</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>

                <v-list-item :to="{ name: 'exportBillingPatientStatement' }">
                  <v-list-item-avatar>
                    <v-icon color="accent" small>fas fa-link</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Patient Statements</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>url</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>

                <div>
                  <v-subheader
                    ><span class="body-1">Sliding Scales</span></v-subheader
                  >
                  <div
                    class="ml-10 grey--text text--darken-2"
                    v-if="!slidingScaleFileList.length"
                  >
                    No data available
                  </div>
                  <div v-for="file in slidingScaleFileList" :key="file.id">
                    <v-list-item :href="`/api/file2/${file.id}/download`">
                      <v-list-item-avatar>
                        <v-icon color="accent" small>fas fa-download</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ file.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </div>
                <div>
                  <v-subheader
                    ><span class="body-1">Fee Schedules</span></v-subheader
                  >
                  <div
                    class="ml-10 grey--text text--darken-2"
                    v-if="!feeScheduleFileList.length"
                  >
                    No data available
                  </div>
                  <div v-for="file in feeScheduleFileList" :key="file.id">
                    <v-list-item :href="`/api/feeSchedule/download/${file.id}`">
                      <v-list-item-avatar>
                        <v-icon color="accent" small>fas fa-download</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ file.name }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text>csv</v-list-item-action-text>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </div>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Breadcrumbs from "@/views/Breadcrumbs";

export default {
  components: {
    Breadcrumbs,
  },
  computed: {
    feeScheduleFileList() {
      let fileList = this.getFileListByAttribute("fileTypeId", 6);
      return fileList;
    },
    payorListUrl() {
      if (this.payorListFileId) {
        return `/api/file2/${this.payorListFileId}/download`;
      }
      return null;
    },
    slidingScaleFileList() {
      let fileList = this.getFileListByAttribute("fileTypeId", 5);
      return fileList;
    },
    ...mapGetters({
      getFileListByAttribute: "file2/filterByAttributeValue",
    }),
    ...mapState({
      organization: state => state.organization.record,
      organizationId: state => state.session.user.organizationId,
    }),
  },
  async created() {
    await Promise.all([
      this.getOrganization(this.organizationId),
      this.getFileList(),
    ]);
    this.payorListFileId = this.organization.billingPayorListAttachment;
  },
  data() {
    return {
      payorListFileId: null,
    };
  },
  methods: {
    ...mapActions({
      getOrganization: "organization/getByOrganizationId",
      getFileList: "file2/list",
    }),
  },
};
</script>
